import { AxiosInstance } from 'axios';
import { useState, FormEvent, useEffect, SyntheticEvent } from 'react';

import { Classes, Button, ControlGroup, FormGroup, InputGroup, Dialog, DialogBody, HTMLSelect, HTMLTable, MenuItem, type MenuItemProps } from '@blueprintjs/core';
import { Suggest, Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { IconNames } from "@blueprintjs/icons";

import * as utils from "./utils";
import { Account, IPOInfo, FBSAccount, FBSCCYInfo } from './Types'
import { click } from '@testing-library/user-event/dist/click';

interface SystemHeaderProps {
    companyLogo: string
    companyName: string
    dataPath: string
    tradeDate: string
    settlementDate: string
}

export interface PageInfo {
    n: number
}

interface PageInfo2 {
    pageno: number,
    pageShow: boolean,
    pageStartno: number,
    pageEndno: number,
    pageLast: boolean,
}


export function SystemHeader({companyLogo, companyName, dataPath, tradeDate, settlementDate}: SystemHeaderProps) {
    const coLogo = <img className="coLogo" src={companyLogo} alt="Co Logo" />
    const coHead = <div style={{display: 'flex', width:'100%', marginTop: '8px'}}>
        {coLogo}
        <div style={{width: '100%', marginLeft: '8px'}}>
            <div style={{display: 'flex', width: '100%'}}>
                <div id="DispCoName" style={{width: '85%'}}> <b>{ companyName } </b> </div>
                <div id="DispTrnDate" style={{width: '15%', textAlign: 'right'}}>Tran Date: {tradeDate} </div>
            </div>
            <div style={{display: 'flex', width: '100%'}}>
                <div id="DispCoName2" style={{width: '85%'}}>Curr Path: {dataPath}</div>
                { (settlementDate.substr(0,2) != "  ") && <div id="DispTrnDate" style={{width: '15%', textAlign: 'right'}}>Setl Date: {settlementDate} </div> }
            </div>
        </div>
    </div>

    return coHead
}


interface ClientPickerProps {
    gsb: AxiosInstance
    isOpen: boolean
    onSelect?: (ac: Account) => void
    onClose?: () => void
}

export function ClientPicker({gsb, isOpen, onSelect = ()=>{}, onClose = ()=>{}}: ClientPickerProps) {
    const [searchKey, setSearchKey] = useState("acCode")
    const [searchValue, setSearchValue] = useState("")

    const [showFilters, setShowFilters] = useState(false)

    const [searchIdNo, setSearchIdNo] = useState("")
    const [searchTel, setSearchTel] = useState("")
    const [searchStatus, setSearchStatus] = useState("")

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [aPageShowInfo, setaPageShowInfo] = useState([] as PageInfo2[])
    const [PageReachEnd, setPageReachEnd] = useState(false)
    const [MoblieDev, setMoblieDev] = useState(false)

    const [data, setData] = useState([] as Account[])


    async function listRec() {

        setnPage(0)
        setnTotalPage(0)
        setPageReachEnd(false)

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }

        const res = await gsb.post('/Master',
        {   sb_data: {
                by: searchKey,
                start: searchValue,
                nPage: 1,
                limit: 50,
                PageShowInfo: aPageShowInfo,
                refreshPageShow: true,
                backward: false,
                SortByName: false,
                filters: {
                    idNo: searchIdNo,
                    tel: searchTel,
                    status: searchStatus
                },
            },
            cPgmId: "CLMast",
            cAction: "ListRec",
        });

        //console.log("ListRec res.data.data", res.data.data)
        //console.log("ListRec res.data.count", res.data.count)
        setaPageShowInfo(res.data.PageShowInfo)
        setData(res.data.data)

        if ( res.data.count > 0 ) {
            const aPageNumber1 = []
            let k = 0
            for ( let j = 1; j <= res.data.PageShowInfo.length; j++ ) {
                if ( res.data.PageShowInfo[j-1].pageShow ) {
                    k++
                    aPageNumber1.push({n: res.data.PageShowInfo[j-1].pageno});
                    if ( res.data.PageShowInfo[j-1].pageLast ) { 
                        setnTotalPage(res.data.PageShowInfo[j-1].pageno)
                        setPageReachEnd(true)
                    }
                }
            }
            setaPageNumber(aPageNumber1)
            setnPage(1)
        }
    }

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0  ) {
    
            setPageReachEnd(false)

            ;
    
            (async () => {
                try {
                    //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                    const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: 50,
                            PageShowInfo: aPageShowInfo,
                            refreshPageShow: false,
                            backward: false,
                            SortByName: false,
                            filters: {
                                idNo: searchIdNo,
                                tel: searchTel,
                                status: searchStatus
                            },
                            },
                        cPgmId: "CLMast",
                        cAction: "ListRec",
                    });

                    //console.log("ListRec Press  res.data.PageShowInfo", res.data.PageShowInfo)
                    setData(res.data.data)
                    setaPageShowInfo(res.data.PageShowInfo)


                    if ( res.data.count > 0 ) {
                        const aPageNumber1 = []
                        let k = 0
                        for ( let j = 1; j <= res.data.PageShowInfo.length; j++ ) {
                            if ( res.data.PageShowInfo[j-1].pageShow ) {
                                k++
                                aPageNumber1.push({n: res.data.PageShowInfo[j-1].pageno});
                                if ( res.data.PageShowInfo[j-1].pageLast ) { 
                                    setnTotalPage(res.data.PageShowInfo[j-1].pageno)
                                    setPageReachEnd(true)
                                }
                            }
                        }
                        setaPageNumber(aPageNumber1)
                        //console.log("ListRec Press k", k, aPageNumber1)
                    }
    
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage])

        

    function PageNo(n: number) {
        if (n > 0 ) {
            if (  nPage+n <= nTotalPage || nTotalPage == 0 ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }


    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nPage > 0) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                 {aPageNumber.map((no, j) => 
                    (no.n < nPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (no.n > nPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nPage > 0) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
                { (nPage > 0) && ! ( PageReachEnd ) &&
                    <Button minimal >...</Button>
                }
            </FormGroup>
        </div>
    </>

    let list = <>
        <div className="Spacing-V-16" />
        {nPage > 0 && Pagination}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-ACCode">Account</th>
                <th className="TCol-ACName">Name</th>
                <th className="TCol-IDNo">ID</th>
                <th className="TCol-Tel">Phone</th>
                <th className="TCol-AECode">Runner</th>
                <th className="TCol-Status">Status</th>
            </thead>
            <tbody>
                {data.map((ac, i) =>
                    <tr key={i} onDoubleClick={() => { onSelect(ac) }}>
                        <td className="TCol-ACCode" onClick={() => { MoblieDev && onSelect(ac) }}>{ac.d_acCode}</td>
                        <td className="TCol-ACName" onClick={() => { MoblieDev && onSelect(ac) }}>{ac.d_acName1}</td>
                        <td className="TCol-IDNo">{ac.d_idNo}</td>
                        <td className="TCol-Tel">{ac.d_tel}</td>
                        <td className="TCol-AECode">{ac.d_aeCode}</td>
                        <td className="TCol-Status">{ac.d_status}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
    </>

    return <Dialog isOpen={isOpen} onClose={onClose} style={{minWidth: '66.67%', height: '60vh'}}>
        <DialogBody>
            <form onSubmit={(e)=>{e.preventDefault(); e.stopPropagation(); listRec()}}>
            <div className="Row-8 No-Print">
                <FormGroup className="Col-1-5" label="Search for Client Master" labelFor="inputSearchValue">
                    <ControlGroup fill>
                        <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                            <option value="acCode">Account</option>
                            <option value="acName">Name</option>
                            <option value="aeCode">Runner</option>
                            {/* <option value="_recordNo">Record No.</option> */}
                        </HTMLSelect>
                        <InputGroup
                            id="inputSearchValue"
                            placeholder="Search"
                            value={searchValue}
                            onChange={utils.handleStringChange(s => setSearchValue(s))}
                            leftIcon="search"
                            rightElement={<Button icon={IconNames.ARROW_RIGHT} minimal onClick={() => {listRec()} } ></Button>}
                        />
                    </ControlGroup>
                </FormGroup>
                <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" onClick={() => {listRec()} } >List</Button>
                {/* <Checkbox className="Col-6-1 Checkbox-LabeledFormGroup" label="Backward" onChange={utils.handleBooleanChange(v => setSearchBackward(v))} /> */}
                {/* <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button> */}
            </div>
            </form>
            {list}
        </DialogBody>
    </Dialog>
}

interface IPOStockPickerProps {
    gsb: AxiosInstance
    isOpen: boolean
    onSelect?: (ac: IPOInfo) => void
    onClose?: () => void
}


export function IPOStockPicker({gsb, isOpen, onSelect = ()=>{}, onClose = ()=>{}}: IPOStockPickerProps) {
    const [searchKey, setSearchKey] = useState("StkNo")
    const [searchValue, setSearchValue] = useState("")

    const [showFilters, setShowFilters] = useState(false)

    const [searchIdNo, setSearchIdNo] = useState("")
    const [searchTel, setSearchTel] = useState("")
    const [searchStatus, setSearchStatus] = useState("")

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [aPageShowInfo, setaPageShowInfo] = useState([] as PageInfo2[])
    const [PageReachEnd, setPageReachEnd] = useState(false)
    const [MoblieDev, setMoblieDev] = useState(false)

    const [data, setData] = useState([] as IPOInfo[])

    const [searchStkName, setsearchStkName] = useState("")
    const [searchApplyDate, setsearchApplyDate] = useState("")

    const [searchStkNo, setsearchStkNo] = useState("")        
    const [searchStk, setsearchStk] = useState("")

    async function listRec() {

        setnPage(0)
        setnTotalPage(0)
        setPageReachEnd(false)

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }

        const res = await gsb.post('/Master',
        {   sb_data: {
                by: searchKey,
                start: searchValue,
                nPage: 1,
                limit: 50,
                PageShowInfo: aPageShowInfo,
                refreshPageShow: true,
                backward: false,
                SortByName: false,
                filters: {
                    Stk: searchStk,
                    StkName: searchStkName,
                    AppyDate:searchApplyDate,
                },
            },
            cPgmId: "IPOMast",
            cAction: "ListRec",
        });

        //console.log("ListRec res.data.data", res.data.data)
        //console.log("ListRec res.data.count", res.data.count)
        setaPageShowInfo(res.data.PageShowInfo)
        setData(res.data.data)

        if ( res.data.count > 0 ) {
            const aPageNumber1 = []
            let k = 0
            for ( let j = 1; j <= res.data.PageShowInfo.length; j++ ) {
                if ( res.data.PageShowInfo[j-1].pageShow ) {
                    k++
                    aPageNumber1.push({n: res.data.PageShowInfo[j-1].pageno});
                    if ( res.data.PageShowInfo[j-1].pageLast ) { 
                        setnTotalPage(res.data.PageShowInfo[j-1].pageno)
                        setPageReachEnd(true)
                    }
                }
            }
            setaPageNumber(aPageNumber1)
            setnPage(1)
        }
    }

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0  ) {
    
            setPageReachEnd(false)

            ;
    
            (async () => {
                try {
                    //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                    const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: 50,
                            PageShowInfo: aPageShowInfo,
                            refreshPageShow: false,
                            backward: false,
                            SortByName: false,
                            filters: {
                                Stk: searchStk,
                                StkName: searchStkName,
                                AppyDate:searchApplyDate,
                            },
                            },
                            cPgmId: "IPOMast",
                            cAction: "ListRec",
                    });

                    //console.log("ListRec Press  res.data.PageShowInfo", res.data.PageShowInfo)
                    setData(res.data.data)
                    setaPageShowInfo(res.data.PageShowInfo)


                    if ( res.data.count > 0 ) {
                        const aPageNumber1 = []
                        let k = 0
                        for ( let j = 1; j <= res.data.PageShowInfo.length; j++ ) {
                            if ( res.data.PageShowInfo[j-1].pageShow ) {
                                k++
                                aPageNumber1.push({n: res.data.PageShowInfo[j-1].pageno});
                                if ( res.data.PageShowInfo[j-1].pageLast ) { 
                                    setnTotalPage(res.data.PageShowInfo[j-1].pageno)
                                    setPageReachEnd(true)
                                }
                            }
                        }
                        setaPageNumber(aPageNumber1)
                        //console.log("ListRec Press k", k, aPageNumber1)
                    }
    
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage])

        

    function PageNo(n: number) {
        if (n > 0 ) {
            if (  nPage+n <= nTotalPage || nTotalPage == 0 ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }


    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nPage > 0) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                 {aPageNumber.map((no, j) => 
                    (no.n < nPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (no.n > nPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nPage > 0) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
                { (nPage > 0) && ! ( PageReachEnd ) &&
                    <Button minimal >...</Button>
                }
            </FormGroup>
        </div>
    </>

    let list = <>
        <div className="Spacing-V-16" />
        {nPage > 0 && Pagination}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-ACCode">Stock No.</th>
                <th className="TCol-ACName">Stock Code</th>
                <th className="TCol-IDNo">Stock name</th>
                <th className="TCol-IDNo">Stock name(Big5)</th>
                <th className="TCol-Tel">LotSize</th>
                <th className="TCol-AECode">Apply Date</th>
                <th className="TCol-Status">Listing Date</th>
            </thead>
            <tbody>
                {data.map((ac, i) =>
                    <tr key={i} onDoubleClick={() => { onSelect(ac) }}>
                        <td className="TCol-ACCode" onClick={() => { MoblieDev && onSelect(ac) }}>{ac.d_StkNo}</td>
                        <td className="TCol-ACName" onClick={() => { MoblieDev && onSelect(ac) }}>{ac.d_StkCode}</td>
                    
                        <td className="TCol-IDNo">{ac.d_StkName}</td>
                        <td className="TCol-ACName" onClick={() => { MoblieDev && onSelect(ac) }}>{ac.d_Chi_Name_bg5}</td>
                   
                        <td className="TCol-Tel">{ac.d_LotSize}</td>
                        <td className="TCol-AECode">{ac.d_ApplyDate}</td>
                        <td className="TCol-Status">{ac.d_ListingDate}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
    </>



    return <Dialog isOpen={isOpen} onClose={onClose} style={{minWidth: '66.67%', height: '60vh'}}>
    <DialogBody>
        <form onSubmit={(e)=>{e.preventDefault(); e.stopPropagation(); listRec()}}>
        <div className="Row-8 No-Print">
            <FormGroup className="Col-1-5" label="Search for IPO Master" labelFor="inputSearchValue">
                <ControlGroup fill>
                    <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                        <option value="StkNo">StockNo</option>
                        <option value="StkName">StockName</option>
                        {/* <option value="_recordNo">Record No.</option> */}
                    </HTMLSelect>
                    <InputGroup
                        id="inputSearchValue"
                        placeholder="Search"
                        value={searchValue}
                        onChange={utils.handleStringChange(s => setSearchValue(s))}
                        leftIcon="search"
                        rightElement={<Button icon={IconNames.ARROW_RIGHT} minimal onClick={() => {listRec()} } ></Button>}
                    />
                </ControlGroup>
            </FormGroup>
            <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" onClick={() => {listRec()} } >List</Button>
            {/* <Checkbox className="Col-6-1 Checkbox-LabeledFormGroup" label="Backward" onChange={utils.handleBooleanChange(v => setSearchBackward(v))} /> */}
            {/* <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button> */}
        </div>
        </form>
        {list}
    </DialogBody>
</Dialog>
}

interface PaginationProps {
    nPage: number
    nTotalPage: number
    aPageNumber: PageInfo[]
    setnPage: (nPage: number) => void
}

export function Pagination({nPage, nTotalPage, aPageNumber, setnPage}: PaginationProps) {
    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    return <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page&nbsp;
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>
}

interface FBSClientPickerProps {
    gsb: AxiosInstance
    isOpen: boolean
    onSelect?: (ac: FBSAccount) => void
    onClose?: () => void
}

export function FBSClientPicker({gsb, isOpen, onSelect = ()=>{}, onClose = ()=>{}}: FBSClientPickerProps) {
    const [searchKey, setSearchKey] = useState("acCode")
    const [searchValue, setSearchValue] = useState("")

    const [showFilters, setShowFilters] = useState(false)

    const [searchIdNo, setSearchIdNo] = useState("")
    const [searchTel, setSearchTel] = useState("")
    const [searchStatus, setSearchStatus] = useState("")

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [aPageShowInfo, setaPageShowInfo] = useState([] as PageInfo2[])
    const [PageReachEnd, setPageReachEnd] = useState(false)
    const [MoblieDev, setMoblieDev] = useState(false)

    const [data, setData] = useState([] as FBSAccount[])


    async function listRec() {

        setnPage(0)
        setnTotalPage(0)
        setPageReachEnd(false)

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }

        const res = await gsb.post('/fbs/Master',
        {   sb_data: {
                by: searchKey,
                start: searchValue,
                nPage: 1,
                limit: 50,
                // PageShowInfo: aPageShowInfo,
                // refreshPageShow: true,
                backward: false,
                SortByName: false,
                filters: {
                    idNo: searchIdNo,
                    tel: searchTel,
                    status: searchStatus
                },
            },
            cPgmId: "CLMast",
            cAction: "ListRec",
        });

        //console.log("ListRec res.data.data", res.data.data)
        //console.log("ListRec res.data.count", res.data.count)
        setaPageShowInfo(res.data.PageShowInfo)
        setData(res.data.data)

        if ( res.data.count > 0 ) {
            const aPageNumber1 = []
            if ( res.data.count > 0 ) {
                setnTotalPage(Math.ceil(res.data.count / 50))
                for ( let j = 1; j <= Math.ceil(res.data.count / 50); j++ ) {
                    aPageNumber1.push({n: j});
                }
                setaPageNumber(aPageNumber1)
                setnPage(1)
            }

            // let k = 0
            // for ( let j = 1; j <= res.data.PageShowInfo.length; j++ ) {
            //     if ( res.data.PageShowInfo[j-1].pageShow ) {
            //         k++
            //         aPageNumber1.push({n: res.data.PageShowInfo[j-1].pageno});
            //         if ( res.data.PageShowInfo[j-1].pageLast ) { 
            //             setnTotalPage(res.data.PageShowInfo[j-1].pageno)
            //             setPageReachEnd(true)
            //         }
            //     }
            // }
            // setaPageNumber(aPageNumber1)
            // setnPage(1)
        }
    }

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0  ) {
    
            setPageReachEnd(false)

            ;
    
            (async () => {
                try {
                    //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                    const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: 50,
                            // PageShowInfo: aPageShowInfo,
                            // refreshPageShow: false,
                            backward: false,
                            SortByName: false,
                            filters: {
                                idNo: searchIdNo,
                                tel: searchTel,
                                status: searchStatus
                            },
                            },
                        cPgmId: "CLMast",
                        cAction: "ListRec",
                    });

                    //console.log("ListRec Press  res.data.PageShowInfo", res.data.PageShowInfo)
                    setData(res.data.data)
                    // setaPageShowInfo(res.data.PageShowInfo)


                    // if ( res.data.count > 0 ) {
                    //     const aPageNumber1 = []
                    //     let k = 0
                    //     for ( let j = 1; j <= res.data.PageShowInfo.length; j++ ) {
                    //         if ( res.data.PageShowInfo[j-1].pageShow ) {
                    //             k++
                    //             aPageNumber1.push({n: res.data.PageShowInfo[j-1].pageno});
                    //             if ( res.data.PageShowInfo[j-1].pageLast ) { 
                    //                 setnTotalPage(res.data.PageShowInfo[j-1].pageno)
                    //                 setPageReachEnd(true)
                    //             }
                    //         }
                    //     }
                    //     setaPageNumber(aPageNumber1)
                    //     //console.log("ListRec Press k", k, aPageNumber1)
                    // }
    
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage])

    let pagination = <Pagination nPage={nPage} nTotalPage={nTotalPage} aPageNumber={aPageNumber} setnPage={(n)=>setnPage(n)}></Pagination>

    let list = <>
        <div className="Spacing-V-16" />
        {nPage > 0 && pagination}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-ACCode">Account</th>
                <th className="TCol-ACName">Name</th>
                <th className="TCol-IDNo">ID</th>
                <th className="TCol-Tel">Phone</th>
                <th className="TCol-AECode">Runner</th>
                <th className="TCol-Status">Status</th>
            </thead>
            <tbody>
                {data.map((ac, i) =>
                    <tr key={i} onDoubleClick={() => { onSelect(ac) }}>
                        <td className="TCol-ACCode" onClick={() => { MoblieDev && onSelect(ac) }}>{ac.d_Acct}</td>
                        <td className="TCol-ACName" onClick={() => { MoblieDev && onSelect(ac) }}>{(ac.d_Name.trim()+" "+ac.d_Name2.trim()).trim()}</td>
                        <td className="TCol-IDNo">{ac.d_IDNo}</td>
                        <td className="TCol-Tel">{ac.d_OPhone}</td>
                        <td className="TCol-AECode">{ac.d_Runner}</td>
                        <td className="TCol-Status">{ac.d_Status}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
    </>

    return <Dialog isOpen={isOpen} onClose={onClose} style={{minWidth: '66.67%', height: '60vh'}}>
        <DialogBody>
            <form onSubmit={(e)=>{e.preventDefault(); e.stopPropagation(); listRec()}}>
            <div className="Row-8 No-Print">
                <FormGroup className="Col-1-5" label="Search for Client Master" labelFor="inputSearchValue">
                    <ControlGroup fill>
                        <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                            <option value="acct">Account</option>
                            <option value="name">Name</option>
                            <option value="runner">Runner</option>
                            {/* <option value="_recordNo">Record No.</option> */}
                        </HTMLSelect>
                        <InputGroup
                            id="inputSearchValue"
                            placeholder="Search"
                            value={searchValue}
                            onChange={utils.handleStringChange(s => setSearchValue(s))}
                            leftIcon="search"
                            rightElement={<Button icon={IconNames.ARROW_RIGHT} minimal onClick={() => {listRec()} } ></Button>}
                        />
                    </ControlGroup>
                </FormGroup>
                <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" onClick={() => {listRec()} } >List</Button>
                {/* <Checkbox className="Col-6-1 Checkbox-LabeledFormGroup" label="Backward" onChange={utils.handleBooleanChange(v => setSearchBackward(v))} /> */}
                {/* <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button> */}
            </div>
            </form>
            {list}
        </DialogBody>
    </Dialog>
}

interface FBSCCYSuggestProps {
    items: FBSCCYInfo[]
    selectedItem: FBSCCYInfo | undefined
    onItemSelect: (item: FBSCCYInfo) => void
}

export function FBSCCYSuggest({items, selectedItem, onItemSelect = ()=>{}}: FBSCCYSuggestProps) {
    const ccyRenderer: ItemRenderer<FBSCCYInfo> = (CurrencyList, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${CurrencyList.d_CurcyName}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={CurrencyList.d_Curcy}
                key={CurrencyList.d_Curcy}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const ccyPredicate: ItemPredicate<FBSCCYInfo> = (query, CurrencyList, _index, exactMatch) => {
        const normalizedText = `${CurrencyList.d_Curcy} - ${CurrencyList.d_CurcyName}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const ccyValueRenderer = (CurrencyList: FBSCCYInfo) => {
        return CurrencyList.d_Curcy
    }

    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    return <Suggest2
                inputProps={{ placeholder: "Currency ..." }}
                selectedItem={selectedItem}
                items={items}
                itemRenderer={ccyRenderer}
                itemPredicate={ccyPredicate}
                inputValueRenderer={ccyValueRenderer}
                onItemSelect={(ccyInfo) => { onItemSelect(ccyInfo) }}
            />
}

interface MenuSuggestProps {
    items: MenuItemProps[]
    selectedItem: MenuItemProps | undefined
    onItemSelect: (item: MenuItemProps) => void
}

export function MenuSuggest({items, selectedItem, onItemSelect = ()=>{}}: MenuSuggestProps) {
    const menuItemRenderer: ItemRenderer<MenuItemProps> = (menuItem, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${menuItem.text}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                onClick={handleClick}
                label={menuItem.label}
                // key={menuItem.key}
                href={menuItem.href}
                text={highlightText(text, query)}
            />
        );
    };

    const menuItemPredicate: ItemPredicate<MenuItemProps> = (query, menuItem, _index, exactMatch) => {
        const normalizedText = `${menuItem.label} ${menuItem.text}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const menuItemValueRenderer = (menuItem: MenuItemProps): string => {
        return menuItem.text?.toString() || ""
    }

    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    return <Suggest
        resetOnClose
        openOnKeyDown
        inputProps={{ leftIcon: "search", placeholder: "Search ..." }}
        selectedItem={selectedItem}
        items={items}
        itemDisabled={"disabled"}
        itemRenderer={menuItemRenderer}
        itemPredicate={menuItemPredicate}
        inputValueRenderer={menuItemValueRenderer}
        onItemSelect={(item) => { window.location.assign(item.href || "") }}
    />
    
}

interface AutoPrintProps {
    href: string
    printed: boolean
    onLoad: () => void
}

export function AutoPrint({ href, printed, onLoad } : AutoPrintProps) {
    const iframeLoaded = (event: SyntheticEvent<HTMLIFrameElement, Event>) => {
        onLoad()
        if (! printed) {
            let frame = (event.currentTarget as HTMLIFrameElement)
            let w = frame.contentWindow
            w?.focus()
            w?.print() // Doesn't work in debug mode due to browser security because gsbweb & gsbsvc "origin" not same
        }
    }
    return <iframe style={{display: "none"}} src={href} onLoad={iframeLoaded}></iframe>
}
